import api, {handleAPIErrors} from 'shared/api'

const FETCH_REQUEST = 'remunerations/FETCH_REQUEST'
const FETCH_SUCCESS = 'remunerations/FETCH_SUCCESS'
const FETCH_FAILURE = 'remunerations/FETCH_FAILURE'


const initialState = {
  remunerations: [{
    id: 0,
    salary: "0.0",
    sti_cash_bonus: "0.0",
    sti_shares_bonus: null,
    other: "0.0",
    restricted_share: "0.0",
    performance_right: "0.0",
    cash: "0.0",
    super: "0.0",
    option: "0.0",
    profit_share: null,
    expat_benefit: null,
    one_time_sign_on_bonus: null,
    other_lt: null,
    note: "",
    total_amount: "0.0",
    sti_total: "0.0",
    option: "0.0",
    performance_right: "0.0",
    lti_total: "0.0",
    annual_leave: "0.0",
    long_term_service_leave: "0.0",
    other_all: "0.0",
    profit_share: "0.0",
    total_fixed: "0.0",
    latest: false,
    currency: "AUD",
    csuite_remunerable_id: 0,
    date: "Jun 2019",
    company_id: "0",
    role: "CEO"
  }],
  loaded: false,
  loading: false,
  errors: []
}

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function loadData(options, cb = null) {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api(`api/v1/remunerations`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))

        if(cb) cb()
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors))
        })

        if(cb) cb()
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_SUCCESS:
      let createdIndex = state.remunerations.findIndex(i => i.id === payload.id)
      if (createdIndex < 0) {
        createdIndex = state.remunerations.length
      }
      return Object.assign({}, state, {
        loading: false,
        errors: [],
        remunerations: Object.assign([...state.remunerations], {[createdIndex]: payload}),
      })
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors: errors
      })
    default:
      return state
  }
}

